import React from "react";
import {CustomSocket} from "./CustomSocket";
import {NODE_OUTPUT_MARGIN_RIGHT} from "../../stylingConstants";
import styled from '@emotion/styled';

const StyledOutputContainerDiv = styled.div`
  margin-right: ${NODE_OUTPUT_MARGIN_RIGHT};
  align-self: center;
`;

export const Output = ({output, bindSocket}) => {
    return(
        <StyledOutputContainerDiv>
            <CustomSocket type="output" socket={output.socket} io={output} innerRef={bindSocket} />
        </StyledOutputContainerDiv>
    );
}

export default Output;